import { collectionPoints } from "../../../data/collectionPoints";

export default function CollectionStep({
  country,
  collection,
  setCollection
}) {
  const countryData = collectionPoints[country];

  const points = countryData?.points || [];

  return (
    <div style={{ marginBottom: 40 }}>
      <h3
        style={{
          fontSize: "0.7rem",
          textTransform: "uppercase",
          color: "#C4773B",
          marginBottom: 20
        }}
      >
        Choose Collection Point
      </h3>

      {points.map((p) => (
        <div
          key={p.name}
          onClick={() => setCollection(p)}
          style={{
            padding: 16,
            border:
              collection?.name === p.name
                ? "1px solid #C4773B"
                : "1px solid rgba(26,22,17,0.12)",
            marginBottom: 10,
            cursor: "pointer"
          }}
        >
          <div style={{ fontWeight: 500 }}>
            {p.name}
          </div>

          <div
            style={{
              fontSize: 12,
              color: "#8B7355"
            }}
          >
            {p.address}
          </div>

          <div
            style={{
              fontSize: 11,
              color: "#C4773B"
            }}
          >
            {p.hours}
          </div>
        </div>
      ))}
    </div>
  );
}